/* eslint-disable */
export function decodeMentions (text, users) {
	text = text.replace(/\n/g, "<br>")
	if (users && users.length === 0)
		return text

	let mentions = text.split(':@'),
		toSwap = []

	for (let i = 0; i < mentions.length; i++) {
		let mention = mentions[i];
		mentions[i] = mention.split('@:')
	}

	mentions = mentions.flat()

	for (let i = 0; i < mentions.length; i++) {
		let mention = mentions[i];
		if (mention.includes('mention='))
			toSwap.push(mention.replace('mention=', ''))
	}

	for (let i = 0; i < toSwap.length; i++) {
		let id = parseInt(toSwap[i]),
			user = users.find(u => u.id === id),
			name = 'Użytkownik Leannovatica',
			replace = ':@mention=' + id + '@:'

		if (user)
			name = (user.name) ? user.name : user.email

		text = text.replace(replace, '<div contenteditable="false" class="' + getMentionsClasses() + '" mention="' + id +'">@' + name + '</div>')
	}
	return text
}

export function getMentionsClasses() {
	return 'accent--text lighten-1 font-weight-bold d-inline-block'
}
